var isLocalDev = window.location.hostname.includes('local');
var isNonProd = isLocalDev || window.location.hostname.includes('.dev');
if (isLocalDev) {
    console.log('Running in local development mode');
    window.isLocalDev = isLocalDev;
}

if (isNonProd) {
    console.log('Running in non-prod environment');
    window.isNonProd = isNonProd;
}
